// extracted by mini-css-extract-plugin
export default {"root":"Ace_root_sT89p","editor":"Ace_editor_nKkBU","ace_content":"Ace_ace_content_vJe96","ace_gutter":"Ace_ace_gutter_t31xa","ace_layer":"Ace_ace_layer_S_n6S"};